<!-- navbar with a search bar -->

<script>
  import { onMount } from "svelte";
  import { writable } from "svelte/store";

  import ShoppingCart from "./ShoppingCart.svelte";
  import Fa from "svelte-fa";
  import { faBars } from "@fortawesome/free-solid-svg-icons";
  import { Link } from 'svelte-routing';
  import { navigate } from 'svelte-routing';
  import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';


  /**
   * @type {import('svelte/store').Writable<boolean>}
  */
  export let sidebarStore;
  export let rounded = true;
  </script>

<nav class="sticky top-0 z-10 flex items-center bg-blue-600 text-white px-6 py-4 min-h-[4.9rem]" class:rounded-br-3xl={rounded}>
  <!-- <div class="text-2xl font-bold">
      Logo
  </div> -->
  {#if window.location.pathname === '/'}
    <div on:click={(e) => sidebarStore.update(open => !open)} class="md:hidden">
      <Fa icon={faBars} class="text-2xl mr-2"/>
    </div>
  {/if}
  {#if window.location.pathname !== '/'}
    <div on:click={(e) => navigate('/')}>
      <Fa icon={faArrowLeft} class="text-2xl mr-2"/>
    </div>
  {/if}
  <slot name="left"></slot>
  <div class="flex-grow"></div>
  <slot></slot>
</nav>
